export interface NotificationIconModel {
    userId: number;
    todos: TodoModal[];
  }
  
  export interface TodoModal {
    assigned: boolean;
    clientId: string;
    companyName:string;
    createdDate:string;
    priority: number;
    read: boolean;
    status:string;  
    todoDescription:string;
    manual: boolean | null;
    taskType: string;
    createdBy: number;
    todoType: string | null;
    notes: string | null;
    shortCode: string;
    assignedTo: string;
    todoUuid: string;
    contextId: string | null;
    taskId: string;
    caseCode?: string;
  }
  
  
  export interface NotificationModel {
    clientActionId?:string|null;
    status: string;
    caseId:any;
    isRead: any;
    userId: number | string;
    notification: string;
    lastActive: string | null;
    message: boolean;
    manual?: boolean;
    manualNotificationHeader?: string;
    read: boolean;
    clientCompany?: string;
    clientId?: number;
    userDisplayFirstName?: string;
    userDisplayLastName?: string;
    uuid: string;
    createdAt: string;
    notifyFlag: boolean;
    taskNotification: boolean;
    notificationType?: NotificationTypeEnum;
    id: string;
    isMessage: string;
    isManual:boolean;
    redirectUrl?:string|null;
    todoTypeId?:number;
    clientProductsId?:string|null;
  }
  
  export interface UpdateManualTodoInput {
    notes: string
  }
  
  export enum NotificationTypeEnum {
    MESSAGE = "Context",
    TODO = "Todo",
    NOTIFICATION = "Notification"
  }
  